import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styles } from "./stylesMarketComponents";

interface Props {
  name: string;
  Icon: React.ElementType;
  onRemove?: () => void;
}

const SelectedMarket: React.FC<Props> = ({ name, Icon, onRemove }) => (
  <Box sx={styles.selectedMarket}>
    <Box sx={styles.selectedMarketIconWrapper}>
      <Icon style={styles.selectedMarketIcon} />
    </Box>
    <Typography sx={styles.selectedMarketText}>{name}</Typography>
    <IconButton size="small" onClick={onRemove}>
      <CloseIcon sx={styles.selectedMarketCloseIcon} />
    </IconButton>
  </Box>
);

export default SelectedMarket;
